import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";

type Props = {
  data: Simplify<Content.OurServicesSectionSliceDefaultPrimaryServiceCardsItem>;
};

export default function SupportCard({ data }: Props) {
  return (
    <Card className="shadow-none border-none">
      <CardHeader>
        <CardTitle>
          <div className="flex items-center gap-4">
            <Button
              size="icon"
              className="rounded-full bg-[#EBF7FF] shrink-0 size-14"
            >
              <PrismicNextImage field={data.icon} alt="" />
            </Button>

            <p className="text-3xl font-semibold text-primary">{data.title}</p>
          </div>
        </CardTitle>
      </CardHeader>

      <CardContent className="md:px-24">
        <PrismicRichText
          field={data.description}
          components={{
            paragraph: ({ children }) => (
              <p className="font-merriweather text-lg text-primary">
                {children}
              </p>
            ),
          }}
        />
      </CardContent>
    </Card>
  );
}
